import { render, staticRenderFns } from "./MenuUpdateDialog.vue?vue&type=template&id=11ff8208"
import script from "./MenuUpdateDialog.vue?vue&type=script&lang=js"
export * from "./MenuUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports